import { jsxs as A, jsx as g } from "react/jsx-runtime";
import { forwardRef as C, useContext as R, useRef as w, useImperativeHandle as E, useEffect as f } from "react";
import j from "classnames";
import H from "../builders-icons/dist/systems/search.js";
import { useTracking as N, useReqireLabel as q, getLabel as z } from "../utils.js";
import { InputGroupContext as D } from "../input-group/utils.js";
import c from "./input.module.less.js";
const O = C(function({ classNameWrapper: a, hidden: t, invalid: i, prefix: k, suffix: v, style: y, size: p, ...e }, b) {
  e.tracking === void 0 && (e.tracking = !0), R(D)(e);
  const r = w(null), n = e.type === "checkbox" || e.type === "radio", s = e.type === "switch", x = j(c.input, a, {
    [c.htmlSize]: p,
    [c.isBoolean]: n || s,
    [c.isDisabled]: e.disabled,
    [c.isInvalid]: i,
    [c.isSwitch]: s
  }), l = N(e.tracking);
  return E(b, () => r.current), G(r, n, s), q(r), f(() => {
    const o = r.current, m = ({ target: I }) => {
      var h;
      const d = I, L = d.checked ? "checked" : "unchecked";
      l({
        eventCategory: "input",
        eventAction: n ? L : "change",
        eventLabel: z((h = d.labels) == null ? void 0 : h[0])
      });
    };
    return o == null || o.addEventListener("change", m), () => o == null ? void 0 : o.removeEventListener("change", m);
  }, [l, n]), /* @__PURE__ */ A("span", { className: x, hidden: t, children: [
    n || s || k || e.type === "search" && /* @__PURE__ */ g(H, {}),
    /* @__PURE__ */ g(
      "input",
      {
        ...e,
        tracking: void 0,
        style: { ...y, "--size": p },
        type: e.type === "switch" ? "checkbox" : e.type,
        "aria-invalid": e["aria-invalid"] || i || void 0,
        ref: r
      }
    ),
    n || s || v
  ] });
}), G = (u, a, t) => {
  f(() => {
    u.current && (a || t) && Array.from(u.current.labels || [], (i) => {
      i.toggleAttribute("data-has-boolean", a || t), i.toggleAttribute("data-has-switch", t);
    });
  }, [u, a, t]);
};
export {
  O as Input
};
//# sourceMappingURL=input.js.map
